import { Button } from "components/Button";
import {
  COOKIE_UPDATE,
  COOKIE_VIDEO_MESSAGE,
  translate,
} from "shared/translate";
import { FigureCaption } from "components/FigureCaption";
import { MaxWidth } from "components/MaxWidth";
import { PAGE_TYPE, VIMEO, YOUTUBE, MEDIUM } from "shared/constants";
import { useAppContext } from "shared/useAppContext";
import { useRouter } from "next/router";
import styles from "./Video.module.css";

export const VideoContainer = ({
  caption,
  credits,
  size = MEDIUM,
  type,
  videoId,
}) => {
  const url = getVideoEmbedUrl({ id: videoId, type });

  return (
    <div className="VideoContainer">
      <MaxWidth size={size}>
        <Video caption={caption} credits={credits} url={url} />
      </MaxWidth>
    </div>
  );
};

export const Video = ({ caption, credits, url }) => {
  const { cookies } = useAppContext();

  return (
    <FigureCaption caption={caption} credits={credits}>
      <div className={styles.iframeContainer}>
        {cookies.advertising ? (
          <iframe frameBorder="0" src={url} allow="autoplay; fullscreen" />
        ) : (
          <VideoDisabled />
        )}
      </div>
    </FigureCaption>
  );
};

const VideoDisabled = () => {
  const { locale } = useRouter();

  return (
    <div className={styles.videoDisabled}>
      <div>
        <p>{translate(COOKIE_VIDEO_MESSAGE, locale)}</p>
        <Button href="cookies?redirect=1" hrefType={PAGE_TYPE}>
          {translate(COOKIE_UPDATE, locale)}
        </Button>
      </div>
    </div>
  );
};

export const AutoplayVideo = ({ caption, credits, id, type }) => (
  <Video
    caption={caption}
    credits={credits}
    url={`${getVideoEmbedUrl({ id, type })}${
      type === YOUTUBE
        ? "?rel=0&controls=1&showinfo=0&autoplay=1&loop=1&mute=0"
        : "?title=1&autoplay=1&mute=0"
    }`}
  />
);

function getVideoEmbedUrl({ id, type }) {
  if (type === VIMEO) {
    return `https://player.vimeo.com/video/${id}`;
  }

  if (type === YOUTUBE) {
    return `https://www.youtube-nocookie.com/embed/${id}`;
  }
}
